import { render, staticRenderFns } from "./Designations.vue?vue&type=template&id=d7d70492"
import script from "./Designations.vue?vue&type=script&lang=js"
export * from "./Designations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports